import React from 'react';

export default function EditIcon({color , fill}) {
  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 17 16'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.03736 12.3328C2.0699 12.0399 2.08617 11.8934 2.13048 11.7566C2.1698 11.6351 2.22534 11.5195 2.29561 11.413C2.37482 11.2929 2.47901 11.1887 2.68739 10.9803L12.0418 1.62586C12.8243 0.843461 14.0928 0.843462 14.8752 1.62587C15.6576 2.40827 15.6576 3.6768 14.8752 4.4592L5.52072 13.8136C5.31234 14.022 5.20815 14.1262 5.08804 14.2054C4.98148 14.2757 4.86591 14.3312 4.74447 14.3705C4.60759 14.4149 4.46115 14.4311 4.16826 14.4637L1.771 14.73L2.03736 12.3328Z'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
